import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageLogoBlockConfig } from '@front-platform/content-builder';
import { imageLogoBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface ImageLogoBlockRuntimeConfig {}

export type ImageLogoBlockConfigInput = Partial<
  Omit<ImageLogoBlockConfig, keyof ImageLogoBlockRuntimeConfig> & ImageLogoBlockRuntimeConfig
>;
export type ImageLogoBlockResolvedConfig = Omit<
  ImageLogoBlockConfig,
  keyof ImageLogoBlockRuntimeConfig
> &
  Partial<ImageLogoBlockRuntimeConfig>;
export interface ImageLogoBlockContract extends ConfigComponentContract<
  ImageLogoBlockConfigInput,
  ImageLogoBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-logo-block',
  templateUrl: './image-logo-block.component.html',
  standalone: false,
})
export class ImageLogoBlockComponent implements ImageLogoBlockContract {
  readonly config = input<ImageLogoBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageLogoBlockConfig,
    ImageLogoBlockRuntimeConfig
  >(imageLogoBlockResolveConfig, () => ({ config: this.config() }));
  get width(): string | undefined {
    return this.resolvedConfig()['width'] as unknown as string | undefined;
  }
  get bottomMargin(): string | undefined {
    return this.resolvedConfig()['bottom_margin'] as unknown as string | undefined;
  }
  get logo(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['logo'] as unknown as IContentBuilderFieldImage | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageLogoBlockComponent, { 'keyAliases': {} });
